import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from "@angular/core";
import { List } from "immutable";
import { DownloaderService } from "../../../../core/downloader/downloader.service";
import { MessagingService } from "../../../../core/messaging/messaging.service";
import { SeverityType } from "../../../../core/messaging/severity-type.enum";
import { RetrievalDocumentItem } from "../../retrieval/retrieval-document-list/retrieval-document-list-item-model";
import { RetrievalDocumentListService } from "../../retrieval/retrieval-document-list/retrieval-document-list.service";
import { FormType } from "../form-type.enum";

@Component({
  selector: "app-grid-forms",
  templateUrl: "./grid-forms.component.html",
  styleUrls: ["./grid-forms.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridFormsComponent {
  @Input() chaseId: number;
  @Input() masterDocumentSourceId: number;
  @Input() isFormsPresent = false;

  @Output() uploadFormClicked = new EventEmitter<void>();
  @Output() lastFormDeleted = new EventEmitter<void>();
  isFormsModalVisible = false;
  forms = List<RetrievalDocumentItem>();
  deleteLoading = false;

  constructor(
    private readonly changeDetector: ChangeDetectorRef,
    private downloaderService: DownloaderService,
    private retrievalDocumentService: RetrievalDocumentListService,
    private messagingService: MessagingService

  ) { }

  private assignAndNotify<T>(data: T[]): List<T> {
    this.changeDetector.markForCheck();
    const dataList = List(data);

    return dataList;
  }

  trackByForm(index: number, form: RetrievalDocumentItem): number {
    return form.retrievalSiteDocumentId;
  }

  deleteForm = (form: RetrievalDocumentItem): void => {
    const reqObject = {
      chaseID: this.chaseId,
      masterDocumentSourceID: this.masterDocumentSourceId,
      retrievalSiteDocumentID: form.retrievalSiteDocumentId,
      documentKey: form.documentKey,
      formType: FormType.Attestation,
      fileName: form.fileName,
    };
    this.deleteLoading = true;
    this.retrievalDocumentService.deleteRetrievalDocument(reqObject).subscribe(
      () => {
        this.messagingService.showToast("Form deleted successfully.", SeverityType.SUCCESS);
        this.viewAllForms();
        this.deleteLoading = false;
      },
      () => {
        this.messagingService.showToast("Error while deleting form.", SeverityType.ERROR);
        this.deleteLoading = false;
      }
    );
  }

  viewAllForms = (event?: MouseEvent): void => {
    event?.stopPropagation();
    event?.preventDefault();
    this.isFormsModalVisible = true;
    this.retrievalDocumentService
      .getRetrievalDocuments({
        chaseId: this.chaseId,
        documentSourceId: this.masterDocumentSourceId,
        formType: FormType.Attestation,
      }).subscribe(items => {
        if (items.length > 0) {
          this.forms = this.assignAndNotify(items);
        } else {
          this.lastFormDeleted.emit();
        }
      });
  }

  get formsLinkText(): string {
    return this.isFormsPresent ? "View Forms" : "";
  }

  downloadFile(url: string): void {
    this.downloaderService.fromRawUrl(url);
  }

  onCancel = (): void => {
    this.isFormsModalVisible = false;
  }

}
